import React from 'react';
import { useTranslation } from 'react-i18next';

import './NoResults.module.css';

const NoResults = ({ resetFilterAction }) => {
  const { t } = useTranslation();

  return (
    <div styleName="no-result">
      <i className="fl-announcement" />
      {t('No results were found matching your selection.')}{' '}
      <button onClick={resetFilterAction}>{t('Clear your selection')}</button>
    </div>
  );
};

export default NoResults;
